export default "__VITE_ASSET__rx2M9tsq__"